import React, { ReactElement } from 'react';

import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import { ImageGeneratorRoute } from '~/modules/image-generator';
import { ImageGeneratorSidebarKey } from '~/modules/image-generator/constants';
import analytics from '~/services/analytics';

import { ReactComponent as ImageGeneratorIcon } from '../assets/image_generator.svg';

router.addPrivateRoutes([ImageGeneratorRoute]);

sidebar.addItems({
  a: [
    {
      order: 4,
      key: ImageGeneratorSidebarKey,
      path: ImageGeneratorRoute.path,
      getTitle: ImageGeneratorRoute.getTitle,
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'image_generator',
        });
      },
      Icon: ({ isActive }): ReactElement => {
        return (
          <ImageGeneratorIcon style={{ color: isActive ? '#fff' : '#000' }} />
        );
      },
    },
  ],
});
